export default __webpack_public_path__ + "static/media/Arakh of the Archaeologian.e7aa00d9.jpg";